import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

const SellCallSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M1.02042 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M1.28916 12.8417L15.7767 12.8506L19.9636 18.0313" stroke="#089981" strokeWidth="2"/>
    <path d="M20.0942 18.0313L29.5408 29.8642" stroke="#A40C0C" strokeWidth="2"/>
</svg>)
const SellCall: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {SellCallSvg(props)}
    </SvgIcon>
));
export default SellCall
